const CREATE_PATH = "/widgets/demand-create";
const EDIT_PATH = "/widgets/demand-edit";

function normalizePath(pathname) {
  if (!pathname) {
    return "/";
  }
  return pathname.replace(/\/+$/, "") || "/";
}

export function resolveWidgetMode(pathname) {
  const normalizedPath = normalizePath(pathname);

  if (normalizedPath === CREATE_PATH) {
    return "create";
  }

  if (normalizedPath === EDIT_PATH) {
    return "edit";
  }

  return null;
}

